// extracted by mini-css-extract-plugin
module.exports = {"box":"login_box__IKC8F","imagebox":"login_imagebox__3xMv1","logo":"login_logo__1GqLK","header":"login_header__3SFb-","form":"login_form__1cblj","body":"login_body__hYlQm"};